import SectionTitle from './SectionTitle';

export default function PreviewCarousel() {
  const screenshots = [
    "/image/default/1.jpg",
    "/image/default/2.jpg",
    "/image/default/3.jpg",
  ];

  return (
    <>
      <SectionTitle rightContent="Version 2.4.7 • Updated on May 31, 2024">
        PREVIEW
      </SectionTitle>

      <div className="overflow-x-auto px-4 pb-4">
        <div className="flex gap-3">
          {screenshots.map((src, i) => (
            <img
              key={i}
              src={src}
              alt={`Preview ${i + 1}`}
              className="w-64 h-48 object-cover rounded-lg flex-shrink-0"
            />
          ))}
        </div>
      </div>
    </>
  );
}